module.exports = __webpack_public_path__ + "img/logo_4_la-sirena.01f9e923.png";